import { Field, Form, type FormikProps } from 'formik';
import { getCountries } from '../../constants/countries';
import { GLOBAL_CONSTANTS } from '../../constants/globals';
import {
  AGE_NOTICE,
  SIGN_UP,
  SIGNUP_FIELDS,
} from '../../constants/signUp.constants';
import { undoCamelCase } from '../../helpers/undoCamelCase';
import type { UserSignUp } from '../../interfaces/auth.interface';
import ButtonComponent from '../UI/Button/Button.component';
import { AcceptTerms } from './AcceptTerms';
import { SignUpCoreFieldsGrid } from './SignUpCoreFieldsGrid';
import { SignUpNonCoreFieldsGrid } from './SignUpNonCoreFieldsGrid';

interface SignUpFormGridProps {
  formikProps: FormikProps<UserSignUp>;
  disabled: string;
}

export const SignUpFormGrid = (props: SignUpFormGridProps) => {
  const { PASSWORD, CONFIRM_PASSWORD, COUNTRY, SELECT_COUNTRY } = SIGNUP_FIELDS;
  const countries = getCountries();
  const userConfirmPassword = undoCamelCase(CONFIRM_PASSWORD);
  const userPassword = undoCamelCase(PASSWORD);
  const { formikProps, disabled } = props;
  const { IS_INVALID } = GLOBAL_CONSTANTS;

  return (
    <Form className="Signup__Form needs-validation">
      <SignUpCoreFieldsGrid disabled={disabled} formikProps={formikProps} />
      <SignUpNonCoreFieldsGrid disabled={disabled} formikProps={formikProps} />
      <div className="Signup__UserInput">
        <Field
          as="select"
          className={`Signup__FormInput form-control ${
            formikProps.errors.country && formikProps.touched.country
              ? IS_INVALID
              : ''
          }`}
          disabled={disabled}
          id={COUNTRY}
          name={COUNTRY}
        >
          <option defaultValue={SELECT_COUNTRY}>{SELECT_COUNTRY}</option>
          {countries.map((country, key) => (
            <option key={`${country.name}-${key}`} value={country.name}>
              {country.name}
            </option>
          ))}
        </Field>
        {formikProps.errors.country && formikProps.touched.country ? (
          <p className="custom-invalid-feedback">
            {formikProps.errors.country}
          </p>
        ) : null}
      </div>
      <div className="Signup__UserInput">
        <Field
          className={`Signup__FormInput form-control ${
            formikProps.errors.password && formikProps.touched.password
              ? IS_INVALID
              : ''
          }`}
          disabled={disabled}
          id={PASSWORD}
          name={PASSWORD}
          placeholder={userPassword}
          type={PASSWORD}
        />
        {formikProps.errors.password && formikProps.touched.password ? (
          <p className="custom-invalid-feedback">
            {formikProps.errors.password}
          </p>
        ) : null}
      </div>
      <div className="Signup__UserInput">
        <Field
          className={`Signup__FormInput form-control ${
            formikProps.errors.passwordConfirm &&
            formikProps.touched.passwordConfirm
              ? IS_INVALID
              : ''
          }`}
          disabled={disabled}
          id={CONFIRM_PASSWORD}
          name={CONFIRM_PASSWORD}
          placeholder={userConfirmPassword}
          type={PASSWORD}
        />
        {formikProps.errors.passwordConfirm &&
        formikProps.touched.passwordConfirm ? (
          <p className="custom-invalid-feedback">
            {formikProps.errors.passwordConfirm}
          </p>
        ) : null}
      </div>
      <p className="Signup__AgeNotice">{AGE_NOTICE}</p>
      <AcceptTerms formikProps={formikProps} />
      <ButtonComponent
        className="Signup__Button"
        variant="primary"
        disabled={!formikProps.values.acceptTerms}
        type="submit"
      >
        {SIGN_UP}
      </ButtonComponent>
    </Form>
  );
};
